import React from 'react'
import styles from './OfferTemplateB.module.css'

const OfferTemplateB = ({ invoiceData, getProductItemsTotal }) => {
    const originalPrice = getProductItemsTotal("total");
    const discountedPrice = parseInt(originalPrice * 0.8);
    const savings = parseInt(originalPrice - discountedPrice);

    return (
        <div className={styles.offerWrapper}>
            <div className={styles.offerCard}>
                <div className={styles.headerSection}>
                    <div className={styles.discountBadge}>
                        <span className={styles.discountPercent}>20%</span>
                        <span className={styles.discountText}>OFF</span>
                    </div>
                    <div>
                        <div className={styles.offerTitle}>Exclusive Offer!</div>
                        <div className={styles.offerSubTitle} >Get all the same services in just</div>
                    </div>
                </div>

                <div className={styles.priceSection}>
                    <div className={styles.priceRow}>
                        <span className={styles.label}>Regular:</span>
                        <span className={styles.originalPrice}>₹{originalPrice}</span>
                    </div>
                    <div className={styles.priceRow}>
                        <span className={styles.label}>Next Visit:</span>
                        <span className={styles.discountedPrice}>₹{discountedPrice}</span>
                    </div>
                    <div className={styles.savingsTag}>
                        You Save ₹{savings}!
                    </div>
                </div>

                <div className={styles.messageSection}>
                    <p className={styles.cta}>Keep Visiting!</p>
                </div>
            </div>
        </div>
    )
}

export default OfferTemplateB